// Paymentfail.jsx
import React from "react";
import "./payment.scss";
import { Button, Layout } from "antd";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";

const { Footer } = Layout;

const PaymentFail = () => {
  return (
    <>
      <div className="payment-success-page">
        <div className="fail-box">
          <div className="icon-circle-fail">
            <CloseOutlined style={{ fontSize: "36px", color: "#E31A32" }} />
          </div>
          <h2>Purchase failed</h2>
          <p>
            Unfortunately, your recent purchase attempt was not successful.
            There may have been an issue with payment processing or a problem
            with the information provided. Please check your payment details and
            try again.
          </p>
          <strong>
            We apologize for the inconvenience and appreciate your patience.
          </strong>
          {/* <Button type="primary" className="back-button">
          ← Go back to payment information
        </Button> */}
        </div>
      </div>
      <Footer>
        <FooterComponent />
      </Footer>
    </>
  );
};
export default PaymentFail;
